<dx-form class="plain-styled-form" [screenByWidth]="getSizeQualifier">
    <dxi-item>
        <dx-text-box
            label="Name *"
            [(value)]="data.name"
            stylingMode='filled'
        >
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </dxi-item>

    <dxi-item>
        <dx-text-area
            label="Description"
            stylingMode="filled"
            [(value)]="data.description"
        >
        </dx-text-area>
    </dxi-item>
</dx-form>
